import React from 'react';
import PropTypes from 'prop-types';

// 전체 동의와 약관별 동의 체크박스를 보여준다.
export default function TermsAgreement({ terms, checked, onChange, disabled }) {
    const allChecked = terms.length > 0 && terms.every(term => checked[term.key]);

    // 전체 동의를 누르면 모든 약관을 같은 값으로 바꾼다.
    function toggleAll(event) {
        onChange(Object.fromEntries(terms.map(term => [term.key, event.target.checked])));
    }

    // 약관 하나의 동의 상태를 바꾼다.
    function toggleOne(key, value) {
        onChange({ ...checked, [key]: value });
    }

    return <fieldset className="auth-terms" disabled={disabled}>
        <legend>약관 동의</legend>
        <label className="auth-terms-all"><input type="checkbox" checked={allChecked} onChange={toggleAll} /><span>전체 동의하기 <small>선택 동의 포함</small></span></label>
        <ul>
            {terms.map(term => <li key={term.key}>
                <label><input type="checkbox" checked={Boolean(checked[term.key])} onChange={event => toggleOne(term.key, event.target.checked)} /><span><em className={term.required ? 'auth-terms-required' : undefined}>[{term.required ? '필수' : '선택'}]</em> {term.title}</span></label>
                {term.url && <a href={term.url} target="_blank" rel="noopener noreferrer" aria-label={`${term.title} 보기`}>보기</a>}
            </li>)}
        </ul>
    </fieldset>;
}

TermsAgreement.propTypes = {
    terms: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string.isRequired, title: PropTypes.string.isRequired, required: PropTypes.bool, url: PropTypes.string })).isRequired,
    checked: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};
